import React, { lazy, Suspense } from "react";
import { Segment } from "semantic-ui-react";
const AuthenticatedApp = lazy(() =>
  import("../../authenticatedApp/components/AuthenticatedApp")
);
import UnauthenticatedApp from "../../unauthenticatedApp/components/UnauthenticatedApp";

const App = ({ error, accessToken, onLogin, onLogout }) => {
  return (
    <>
      {error && <div>Invalid credentials</div>}
      {accessToken ? (
        <Suspense fallback={<Segment loading={true}></Segment>}>
          <AuthenticatedApp onLogout={onLogout} />
        </Suspense>
      ) : (
        <Suspense fallback={<Segment loading={true}></Segment>}>
          <UnauthenticatedApp onLogin={onLogin} />
        </Suspense>
      )}
    </>
  );
};

export default App;
